import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const ComingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({});

  const calculateTimeLeft = () => {
    const launchDate = new Date("2024-12-31T00:00:00").getTime(); // Set your launch date
    const now = new Date().getTime();
    const difference = launchDate - now;

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      return {};
    }
  };

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <motion.div
      className="p-6 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl shadow-xl"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="text-4xl font-bold mb-2">🚀 Coming Soon</h1>
      <p className="mb-4 opacity-90">We’re building something amazing for you.</p>

      {/* Countdown Timer */}
      {Object.keys(timeLeft).length > 0 && (
        <div className="flex justify-center gap-6">
          {Object.entries(timeLeft).map(([unit, value]) => (
            <div key={unit} className="text-center">
              <div className="text-2xl font-bold">{value}</div>
              <div className="uppercase text-xs">{unit}</div>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default ComingSoon;
